import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
import { required, isValidOtp, isValidLength } from '@/lib/rule';
import { defineMessages } from '@/lib/i18n';
import { i18n } from '@/plugins/vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'VerifyForm',
  props: {
  verificationToken: {
    type: String,
    required: true,
  },
  phoneNumber: {
    type: String,
    required: true,
  },
  email: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  mode: {
    type: String,
    required: true,
  },
  emailAuthEnabled: {
    type: Boolean,
    default: false,
  },
  isValidForm: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:isValidForm", "update:verificationToken", "submit"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'update:isValidForm', data: boolean): void;
  (e: 'update:verificationToken', data: string): void;
  (e: 'submit'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const $t = i18n.t.bind(i18n);

const m = defineMessages({
  enterPhoneOtpMessage:
    '続行するには、{phoneNumber} に送信された認証コードを入力してください',
  enterEmailOtpMessage:
    '新しいデバイスからのログインを確認するため、{email} に送信した認証コードを入力してください',
  // Email authentication users are challenged on every login, from any device,
  // so the "new device" wording would be wrong for them.
  enterEmailOtpMessageEveryLogin:
    '{email} に送信した認証コードを入力してください',
  // Session re-verification for users without a usable password (e.g. SAML).
  enterFirstFactorEmailOtpMessage:
    '二要素認証を有効にするため、{email} に送信した認証コードを入力してください',
  enterTotpMessage:
    '続行するには、認証アプリ（Google Authenticatorなど）に表示された6桁のコードを入力してください',
  otpValidity: '認証コードは10分間有効です',
  recoveryCodeLabel: 'リカバリーコード',
  enterBackupCodeMessage:
    '二要素認証を完了するために、以前保存したリカバリーコードのいずれかを使用してください',
  onlyOnce: '各リカバリーコードは1回のみ使用できます',
  enterPasswordToProceed:
    '二要素認証を有効にするため、ケミカンのログインパスワードを入力してください',
});





const otpInput = ref<HTMLInputElement | null>(null);
const showPassword = ref(false);

const updateIsValidForm = (e: boolean) => {
  emits('update:isValidForm', e);
};

const handleEnterKeyPress = (e: KeyboardEvent) => {
  e.preventDefault();
  emits('submit');
};

const updateValue = (e: string) => {
  const completeLength = props.mode === 'backup_code' ? 8 : 6;
  emits('update:verificationToken', e);
  if (
    props.mode !== 'password' &&
    e &&
    e.length === completeLength &&
    // Only auto submit if it was incomplete before
    // Otherwise this will retrigger for each replaced digit.
    props.verificationToken?.length < completeLength
  ) {
    emits('submit');
  }
};

const allowOnlyNumbers = (event: KeyboardEvent) => {
  const charCode = event.charCode ? event.charCode : event.keyCode;
  if (charCode < 48 || charCode > 57) {
    event.preventDefault();
  }
  if (event.key === 'Process' || event.key === 'Unidentified') {
    event.preventDefault();
  }
};

onMounted(() => {
  // Make sure the input is focused when the component is mounted
  setTimeout(() => {
    otpInput.value?.focus();
  }, 100);
});

return { __sfc: true,$t, m, props, emits, otpInput, showPassword, updateIsValidForm, handleEnterKeyPress, updateValue, allowOnlyNumbers, required, isValidOtp, isValidLength }
}

})